"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import MaxWidth from "./MaxWidth";
import { pushGtmEvent } from "@/lib/utils/gtmEventHandler";
export default function Footer(t0) {
  const $ = _c(50);
  const {
    inHomzFooter
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== inHomzFooter || $[1] !== searchParams) {
    t1 = searchParams.get("isLeadGenProfile") === "true" || inHomzFooter === true;
    $[0] = inHomzFooter;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isInHomzFooter = t1;
  const scrollToSection = _temp;
  let t2;
  if ($[3] !== pathname || $[4] !== router) {
    t2 = (e, sectionId_0) => {
      e.preventDefault();
      const isHomePage = pathname === "/";
      if (isHomePage) {
        scrollToSection(sectionId_0);
      } else {
        router.push(`/#${sectionId_0}`);
      }
    };
    $[3] = pathname;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSectionClick = t2;
  let t3;
  let t4;
  if ($[6] !== pathname) {
    t3 = () => {
      if (pathname === "/" && typeof window !== "undefined") {
        const hash = window.location.hash.slice(1);
        if (hash === "how-it-works" || hash === "faq" || hash === "why-trusted") {
          const timer = setTimeout(() => {
            scrollToSection(hash);
          }, 300);
          return () => clearTimeout(timer);
        }
      }
    };
    t4 = [pathname];
    $[6] = pathname;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  const headingText = isInHomzFooter ? "Your Dream Home. Built by People You Choose." : typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage.getItem("landingPage") === "carpenter" ? "Choose the right carpenter for your home with Fevicol Interior Experts" : "Choose the right contractor for your home with Fevicol Interior Experts" : "Choose the right contractor for your home with Fevicol Interior Experts";
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "var(--textPrimaryOnColorPrimary, #F2F1E9)"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== headingText) {
    t6 = <div className="mx-6 lg:mx-0"><h2 className="m3-title-large lg:m3-display-small text-center lg:mb-20 mb-7 p-4" style={t5}>{headingText}</h2></div>;
    $[10] = headingText;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `relative h-[39px] md:mb-0 md:flex-shrink-0 ml-6 lg:ml-0 flex flex-col ${isInHomzFooter ? "w-[206px] mb-7" : "w-[156px] mb-12"}`;
  let t8;
  if ($[12] !== isInHomzFooter) {
    t8 = isInHomzFooter ? <Image src="/logos/fevicol-inhomz-dark-logo.svg" alt="Fevicol Interior Experts" fill={true} sizes="206px" priority={false} /> : <><Image src="/assets/multiply-logo.svg" alt="Multiply logo" fill={true} sizes="(max-width: 768px) 156px, 268px" priority={false} /><Image src="/assets/headline.svg" alt="Multiply logo text" width={162} height={16} priority={false} className="mt-11" /></>;
    $[12] = isInHomzFooter;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h3 className="m3-label-large-prominent my-[18px]" style={{
      color: "var(--textPrimaryOnColorPrimary, #F2F1E9)"
    }}>About</h3>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== handleSectionClick) {
    t11 = e_0 => handleSectionClick(e_0, "why-trusted");
    $[18] = handleSectionClick;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
    };
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11) {
    t13 = <li><Link href="/why-trusted" onClick={t11} className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={t12}>Fevicol Partnership</Link></li>;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== handleSectionClick) {
    t14 = e_1 => handleSectionClick(e_1, "how-it-works");
    $[23] = handleSectionClick;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
    };
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = <li><Link href="/how-it-works" onClick={t14} className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={t15}>How it works?</Link></li>;
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== isInHomzFooter) {
    t17 = !isInHomzFooter && <><li><Link href="/privacy-policy" className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={{
          color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
        }}>Privacy Policy</Link></li><li><Link href="/terms-of-use" className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={{
          color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
        }}>Terms of Use</Link></li></>;
    $[28] = isInHomzFooter;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t13 || $[31] !== t16 || $[32] !== t17) {
    t18 = <div className="flex flex-col sm:min-w-[160px] md:min-w-0 lg:w-[212px]">{t10}<ul className="flex flex-col gap-3">{t13}{t16}{t17}</ul></div>;
    $[30] = t13;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h3 className="m3-label-large-prominent my-[18px]" style={{
      color: "var(--textPrimaryOnColorPrimary, #F2F1E9)"
    }}>For homeowners</h3>;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <li><Link href="/lead-gen-profiles" onClick={_temp2} className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={{
        color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
      }}>Browse contractors</Link></li>;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== handleSectionClick) {
    t21 = e_3 => handleSectionClick(e_3, "faq");
    $[36] = handleSectionClick;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      color: "var(--textSecondaryOnColorSecondary, #C8C7BF)"
    };
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t21) {
    t23 = <div className="flex flex-col sm:min-w-[160px] md:min-w-0 lg:w-[212px]">{t19}<ul className="flex flex-col gap-3">{t20}<li><Link href="/faq" onClick={t21} className="m3-body-medium no-underline hover:opacity-80 transition-opacity" style={t22}>FAQs</Link></li></ul></div>;
    $[39] = t21;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t18 || $[42] !== t23) {
    t24 = <div className="w-full flex flex-col sm:flex-row sm:flex-wrap md:flex-nowrap md:justify-end gap-7 lg:gap-6 px-6 lg:px-0">{t18}{t23}</div>;
    $[41] = t18;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t24 || $[45] !== t9) {
    t25 = <div className="flex flex-col md:flex-row md:items-start md:justify-between max-w-7xl lg:gap-[168.37px]">{t9}{t24}</div>;
    $[44] = t24;
    $[45] = t9;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t25 || $[48] !== t6) {
    t26 = <footer id="main-footer" className="w-full pt-[var(--spacing52)] pb-32 bg-[var(--colorPrimaryOnPrimaryContainer,#06164B)] "><MaxWidth>{t6}{t25}</MaxWidth></footer>;
    $[47] = t25;
    $[48] = t6;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  return t26;
}
function _temp2(e_2) {
  pushGtmEvent({
    event_name: "find_contractors_cta_clicked"
  });
}
function _temp(sectionId) {
  requestAnimationFrame(() => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  });
}